<template>
<div class="box">
  <div class="paybody">
    <div v-bind:class="'payclass payclass1 '+payclassactive[0]" @click="changeVipType(0,$event)" >
      <div class="leftMode">
        <p>月度会员</p>
        <span>+30天VIP会员</span>
      </div>
      <div class="rightMode" v-if="payType === 'fbee'">
        <p><span>特惠价</span>2500FBEE</p>
        <span>原价4000FBEE</span>
      </div>
      <div class="rightMode" v-if="payType === 'eth'">
        <p><span>特惠价</span>0.05ETH</p>
        <span>原价0.08ETH</span>
      </div>
    </div>
    <div v-bind:class="'payclass payclass1 '+payclassactive[1]" @click="changeVipType(1,$event)" >
      <div class="leftMode">
        <p>季度会员</p>
        <span>+90天VIP会员</span>
      </div>
      <div class="rightMode" v-if="payType === 'fbee'">
        <p><span>特惠价</span>5000FBEE</p>
        <span>原价7500FBEE</span>
      </div>
      <div class="rightMode" v-if="payType === 'eth'">
        <p><span>特惠价</span>0.1ETH</p>
        <span>原价0.15ETH</span>
      </div>
    </div>
    <div v-bind:class="'payclass payclass1 '+payclassactive[2]" @click="changeVipType(2,$event)" >
      <div class="leftMode">
        <p>年度会员</p>
        <span>+365天VIP会员</span>
      </div>
      <div class="rightMode" v-if="payType === 'fbee'">
        <p><span>特惠价</span>15000FBEE</p>
        <span>原价25000FBEE</span>
      </div>
      <div class="rightMode" v-if="payType === 'eth'">
        <p><span>特惠价</span>0.3ETH</p>
        <span>原价0.5ETH</span>
      </div>
    </div>
    <p class="paytip">需支付：0.1 ETH</p>
    <label for="fbeepaytype" class="radioLabel" style="margin-top: 0.4rem" @click="choosepaytype('fbee')">
      <div class="ico" style="background-image: url('/static/pay_small_logo_fbee.png')"></div>
      <div class="text"><p>FBEE支付<span class="off50"></span></p><span>请上Bit-z交易所购买</span></div>
      <input type="radio" name="changePayType" value="fbee" id="fbeepaytype" checked style="display: none" />
      <div class="radiostatus"></div>
    </label>
    <label for="ethpaytype" class="radioLabel" @click="choosepaytype('eth')">
      <div class="ico" style="background-image: url('/static/pay_small_logo_eth.png')"></div>
      <div class="text"><p>ETH支付</p></div>
      <input type="radio" name="changePayType" value="eth" id="ethpaytype" style="display: none"/>
      <div class="radiostatus"></div>
    </label>
  </div>
  <div class="bottom_box">
    <a  class="downloadButton" @click="goKTVIp" >开通VIP会员</a>
    <img class="downloadButtonShadow" src="/static/downloadshadow.png">
  </div>
</div>
</template>

<script>
export default {
  name: 'fbeePay',
  data () {
    return {
      payclassactive: ['', '', ''],
      payVipType: '',
      payType: 'fbee'
    }
  },
  methods: {
    changeVipType: function (index, event) {
      this.payclassactive = ['', '', '']
      this.payclassactive[index] = 'payclassactive'
      this.payVipType = index
    },
    choosepaytype: function (str) {
      this.payType = str
    },
    goKTVIp: function () {
      this.$router.push({path: '/waitPay'})
    }
  }
}
</script>

<style scoped>
.box{
  background-color: #0A274A;
  width: 100%;
  height: inherit;
}
.paybody{
  position: absolute;
  width: 9.2rem;
  height: 11.84rem;
  left: 50%;
  transform: translateX(-50%);
  top: 0.4rem;
}
.paybody .payclass{
  height: 2.1333rem;
  background: #FFFFFF;
  border-radius: 0.1333rem;
  box-sizing: border-box;
  margin-bottom: 0.2667rem;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.paybody .payclass .leftMode{
  margin-left: 0.4rem;
}
.paybody .payclass .leftMode p {
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #4A4A4A;
  line-height: 0.9333rem;
}
.paybody .payclass .leftMode span {
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #9B9B9B;
}
.paybody .payclass .rightMode{
  margin-right: 0.4rem;
}
.paybody .payclass .rightMode p {
  font-family: PingFangSC-Medium;
  font-size: 0.6667rem;
  color: #F5A623;
  text-align: right;
  line-height: 0.9333rem;
}
.paybody .payclass .rightMode p span {
  font-family: PingFangSC-Medium;
  font-size: 0.3733rem;
  color: #F5A623;
  text-align: right;
  margin-right: 0.15rem;
}
.paybody .payclass .rightMode>span {
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #9B9B9B;
  text-align: right;
  display: block;
  text-decoration: line-through;
}

.paybody .payclassactive{
  background-color: #FFF5E4;
  border: 0.0533rem solid #F5A623;
}

.paybody .paytip{
  margin-top: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #FFFFFF;
}
.radioLabel{
  height: 1.6rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  position: relative;
}
.radioLabel .ico{
  width: 0.8rem;
  height: 0.8rem;
  background-size: 100%;
}
.radioLabel .text{
  margin-left: 0.2rem;
}
.radioLabel .text>p{
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
.radioLabel .text>p>.off50{
  display: block;
  width: 1.12rem;
  height: 0.587rem;
  background-image: url("/static/5off.png");
  background-size: 100%;
  margin-left: 0.2rem;
}
.radioLabel .text>span{
  opacity: 0.5;
  font-family: PingFangSC-Medium;
  font-size: 0.347rem;
  color: #FFFFFF;
}
.radioLabel .radiostatus{
  position: absolute;
  right: 0px;
  width: 0.667rem;
  height: 0.667rem;
  background-size: 100%;
}
.radioLabel input + .radiostatus{
  background-image: url("/static/checkoutfalse.png");
}
.radioLabel input:checked + .radiostatus{
  background-image: url("/static/checkoutture.png");
}

.bottom_box{
  width: 100%;
  height: 3.04rem;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: rgba(16,31,49,0.60);
  box-shadow: 0 -1px 1px 0 #061629;
}
.downloadButton{
  font-family: PingFangSC-Regular;
  font-size: 0.373rem;
  color: #744A05;
  text-align: center;
  background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
  border-radius: 1.333rem;
  width: 7.467rem;
  height: 1.333rem;
  display: block;
  position: absolute;
  top: 0.467rem;
  line-height: 1.333rem;
  transform: translateX(-50%);
  left: 50%;
  z-index: 3;
}
.downloadButtonShadow{
  position: absolute;
  z-index: 2;
  width: 7.467rem;
  height: 1.733rem;
  left: 50%;
  transform: translateX(-50%);
  top: 0.467rem;
  border-radius: 1.3333rem;
}
</style>



// WEBPACK FOOTER //
// src/components/fbeePay.vue